<template>
  <x-box :title="$t('label.showOrHideColumns')">
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-5">
            <div class="row">
              <div class="col-md-12">
                <h3>{{ $t('string.availableColumns') }}</h3>
              </div>
              <div class="col-md-12">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('string.search')"
                  v-model="invisible_filter_text"
                >
              </div>
              <div class="col-md-12">
                <template v-if="invisible_filter_text">
                  <select
                    multiple
                    class="form-control"
                    size="20"
                    v-model="selected_invisible"
                  >
                    <option
                      v-for="(column, key) in invisibleSearchList"
                      :key="key"
                      :value="column"
                    >
                      {{ key + 1 }} - {{ column['column_name_' + $i18n.locale] }}
                    </option>
                  </select>
                </template>
                <template v-else>
                  <select
                    multiple
                    class="form-control"
                    size="20"
                    v-model="selected_invisible"
                  >
                    <option
                      v-for="(column, key) in invisible"
                      :key="key"
                      :value="column"
                    >
                      {{ key + 1 }} - {{ column['column_name_' + $i18n.locale] }}
                    </option>
                  </select>
                </template>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="switch-block-buttons">
              <button
                class="btn btn-default btn-block text-center"
                @click="copyToVisible"
              >
                <i class="fa fa-chevron-right" />
              </button>
              <button
                class="btn btn-default btn-block text-center"
                @click="copyToInvisible"
              >
                <i class="fa fa-chevron-left" />
              </button>
            </div>
          </div>
          <div class="col-md-5">
            <div class="row">
              <div class="col-md-12">
                <h3>{{ $t('string.shownColumns') }}</h3>
              </div>
              <div class="col-md-12">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('string.search')"
                  v-model="visible_filter_text"
                >
              </div>
              <div class="col-md-12">
                <template v-if="visible_filter_text">
                  <select
                    multiple
                    class="form-control"
                    size="20"
                    v-model="selected_visible"
                  >
                    <option
                      v-for="(column, key) in visibleSearchList"
                      :key="key"
                      :value="column"
                    >
                      {{ key + 1 }} - {{ column['column_name_' + $i18n.locale] }}
                    </option>
                  </select>
                </template>
                <template v-else>
                  <select
                    multiple
                    class="form-control"
                    size="20"
                    v-model="selected_visible"
                  >
                    <option
                      v-for="(column, key) in visible"
                      :key="key"
                      :value="column"
                    >
                      {{ key + 1 }} - {{ column['column_name_' + $i18n.locale] }}
                    </option>
                  </select>
                </template>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="group-btn-move-up-and-down">
                  <button
                    class="btn btn-default text-center"
                    @click="moveUp"
                  >
                    <i class="fa fa-arrow-up" />
                  </button>
                  <button
                    class="btn btn-default text-center"
                    @click="moveDown"
                  >
                    <i class="fa fa-arrow-down" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <hr>
      </div>
      <div class="col-md-12">
        <div class="text-center">
          <button
            class="btn btn-default text-center margin-right-5"
            @click="getList"
          >
            {{ $t('button.reset') }}
          </button>
          <button
            class="btn btn-info text-center"
            @click="onSubmit"
          >
            {{ $t('button.submit') }}
          </button>
        </div>
      </div>
      <div class="col-md-12">
        <hr>
      </div>
      <div class="col-md-12">
        <button
          class="btn btn-default margin-r-5"
          @click="$router.back()"
        >
          {{ $t('button.back') }}
        </button>
      </div>
    </div>
  </x-box>
</template>

<script>
export default {
  name: 'TableColumnManager',
  props: {
    modelType: {
      type: String,
      required: true
    }
  },
  metaInfo () {
    return {
      title: this.$t('string.switchTableColumn'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  data () {
    return {
      visible: [],
      invisible: [],
      selected_visible: [],
      selected_invisible: [],
      visible_filter_text: null,
      invisible_filter_text: null
    }
  },
  computed: {
    invisibleSearchList () {
      if (this.invisible_filter_text) {
        return this.invisible.filter(column => (column['column_name_' + this.$i18n.locale]).toLowerCase().includes((this.invisible_filter_text).toLowerCase()))
      }
      return this.invisible
    },
    visibleSearchList () {
      if (this.visible_filter_text) {
        return this.visible.filter(column => (column['column_name_' + this.$i18n.locale]).toLowerCase().includes((this.visible_filter_text).toLowerCase()))
      }
      return this.visible
    }
  },
  methods: {
    async getList () {
      this.$isLoading(true)
      await this.$axios.post(process.env.VUE_APP_API + '/api/v4/backend/filter-table-column/get-list', {
        model_type: this.modelType
      }).then(({ data }) => {
        if (data.data) {
          const result = data.data
          this.visible = result.visible
          this.invisible = result.invisible
        }
      }).finally(() => {
        this.$isLoading(false)
      })
    },
    onSubmit () {
      this.$isLoading(true)
      this.$axios.post(process.env.VUE_APP_API + '/api/v4/backend/filter-table-column/order-list', {
        model_type: this.modelType,
        visible: this.visible.map(column => column.id)
      }).then(({ data }) => {
        if (data.data) {
          this.showToastr()
          switch (this.modelType) {
            case 'Applicant':
              localStorage.setItem('application_columns', JSON.stringify(data.data))
              break
            case 'Draft':
              localStorage.setItem('draft_columns', JSON.stringify(data.data))
              break
            case 'Client':
              localStorage.setItem('client_columns', JSON.stringify(data.data))
              break
          }
        }
      }).finally(() => {
        this.$isLoading(false)
      })
    },
    copyToInvisible () {
      this.invisible = [...this.invisible, ...this.selected_visible]
      this.selected_visible.forEach((column) => {
        this.visible.splice(this.visible.indexOf(column), 1)
      })
    },
    copyToVisible () {
      this.visible = [...this.visible, ...this.selected_invisible]
      this.selected_invisible.forEach((column) => {
        this.invisible.splice(this.invisible.indexOf(column), 1)
      })
    },
    moveUp () {
      if (this.selected_visible.length) {
        const index = this.visible.indexOf(this.selected_visible[0]) - 1
        this.selected_visible.forEach((column) => {
          this.visible.splice(this.visible.indexOf(column), 1)
        })
        this.visible = [...this.visible.slice(0, index), ...this.selected_visible, ...this.visible.slice(index)]
      }
    },
    moveDown () {
      const index = parseInt(this.visible.indexOf(this.selected_visible[this.selected_visible.length - 1])) + parseInt(1)
      this.selected_visible.forEach((column) => {
        this.visible.splice(this.visible.indexOf(column), 1)
      })
      this.visible = [...this.visible.slice(0, index), ...this.selected_visible, ...this.visible.slice(index)]
    }
  },
  mounted () {
    this.getList()
  }
}
</script>

<style scoped>
.switch-block-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
}

.group-btn-move-up-and-down {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 5px;
  margin-top: 5px;
}

hr {
  border-top: 1px solid #f7f7f7;
}
</style>
